import About from './components/pages/About';
import Service from './components/pages/Services';
import Contact from './components/pages/Contact';
import FAQ from './components/pages/Faq';
import Welcome from './components/WelcomeScreen';
import ImageHero from './components/ImageHero';
// Create a reusable Home component to avoid duplication
const Home = () => (
  <>
    <ImageHero />

  </>
);

const routes = [
  {
    path: '/',
    element: <Welcome />,
  },
  {
    path: '/home',        // This will show the same as /
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/services',
    element: <Service />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/faq',
    element: <FAQ />,
  },
];

export default routes;